import { useState, useEffect } from 'react';
import '../../../entrydoor.css';

const OPTIONS = [
  { value: 'Yes', label: 'Yes' },
  { value: 'No',  label: 'No'  },
];

// Visible only when hinges side matches an existing side lite on the selected door type
const OperatingSideLite = ({ value = { value: '', label: '' }, onChange, disabled = false }) => {
  const [selected,    setSelected]    = useState(value?.value || '');
  const [showWarning, setShowWarning] = useState(false);

  useEffect(() => { setSelected(value?.value || ''); }, [value?.value]);

  const handleChange = (e) => {
    const v = e.target.value;
    const label = OPTIONS.find(o => o.value === v)?.label || v;
    setSelected(v);
    setShowWarning(v === 'Yes');
    onChange({ value: v, label });
  };

  return (
    <div className="a-container">
      <label htmlFor="SdOperatingSideLite">Operating Side Lite</label>
      <select id="SdOperatingSideLite" value={selected} onChange={handleChange} disabled={disabled}>
        {OPTIONS.map(o => (
          <option key={o.value} value={o.value}>
            {selected === o.value ? `${o.label} ✔` : o.label}
          </option>
        ))}
      </select>
      {showWarning && (
        <div className="jamb-warning">
          An Operating Side Lite requires an astragal. Please re-check your Frame Width as it may have changed due to this option.
        </div>
      )}
    </div>
  );
};

export default OperatingSideLite;
